import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { ValidationError } from 'yup';

dayjs.extend(customParseFormat);

export const parseDate = (value: string, originalValue: string | Date) => {
  if (originalValue instanceof Date) {
    return originalValue;
  }
  if (
    originalValue === null ||
    originalValue === undefined ||
    originalValue === ''
  ) {
    return undefined;
  }

  // Try parsing with custom format first
  let date = dayjs(originalValue as string, 'MM/DD/YYYY', true);
  if (date.isValid()) {
    return date.toDate();
  }

  date = dayjs(originalValue as string, 'M/D/YYYY', true);
  if (date.isValid()) {
    return date.toDate();
  }

  date = dayjs(originalValue as string, 'YYYY-MM-DD', true);
  if (date.isValid()) {
    return date.toDate();
  }

  throw new ValidationError(
    `"${originalValue}" is not a valid date in the format MM/DD/YYYY, M/D/YYYY or YYYY-MM-DD`
  );
};

export const transformNumber = (value: any, originalValue: any) => {
  if (
    originalValue === null ||
    originalValue === undefined ||
    originalValue === ''
  ) {
    return undefined;
  }
  return value;
};

export const transformString = (value: any, originalValue: any) => {
  if (
    originalValue === null ||
    originalValue === undefined ||
    originalValue === ''
  ) {
    return undefined;
  }
  return value;
};

export const transformBoolean = (value: any, originalValue: any) => {
  if ([1, '1', true].includes(originalValue)) {
    return 1;
  }
  if ([null, undefined, '', false, 0, '0'].includes(originalValue)) {
    return 0;
  }
  return 1;
};
